import React, {Component} from 'react';
import Styles from './style.css';
import cx from "classnames";
import {BeatLoader} from 'react-spinners';
import {dataRegister} from "../../services/dataRegister";
import {Line, Doughnut} from 'react-chartjs-2';
import {langRegister} from "../../services/langRegister";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import {userRegister} from "../../services/userRegister";
import ModalArchive from "../modal-archive/component";
import queryString from "query-string";
import Moment from "react-moment";

class userCampaignsDraftsItem extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: null,
            time_indicator: true,
            show: true,
            user: {},
            today: new Date(),
            landing_expiry: 61,
            channels_style: {
                line: {
                    instagram: {
                        title: "instagram",
                        backgroundColor: 'rgba(204,237,243, 0.7)',
                    },
                    fb: {
                        title: "facebook",
                        backgroundColor: 'rgba(51,184,207, 0.9)',
                    },
                    bing: {
                        title: "bing",
                        backgroundColor: 'rgba(153,219,231, 0.9)',
                    },
                    google: {
                        title: "google",
                        backgroundColor: 'rgba(26,107,133, 0.9)',
                    }
                },
                doughnut: {
                    instagram: {
                        title: "instagram",
                        backgroundColor: 'rgba(204,237,243, 0.7)',
                        hoverBackgroundColor: 'rgba(204,237,243, 0.7)'
                    },
                    fb: {
                        title: "facebook",
                        backgroundColor: 'rgba(51,184,207, 0.9)',
                        hoverBackgroundColor: 'rgba(51,184,207, 0.9)'
                    },
                    bing: {
                        title: "bing",
                        backgroundColor: 'rgba(153,219,231, 0.9)',
                        hoverBackgroundColor: 'rgba(153,219,231, 0.9)'
                    },
                    google: {
                        title: "google",
                        backgroundColor: 'rgba(26,107,133, 0.9)',
                        hoverBackgroundColor: 'rgba(26,107,133, 0.9)'
                    }
                }
            },
            chartData: {
                labels: ["1", "2", "3", "4", "5", "6"],
                datasets: [{
                    backgroundColor: 'rgba(51,184,207,0.7)',
                    borderColor: '#33b8cf',
                    data: [],
                    borderWidth: 2,
                    radius: 4,
                    pointBackgroundColor: "#ffffff",
                    pointHoverBorderColor: '#33b8cf',
                    pointHoverBackgroundColor: "#ffffff",
                }]
            },
            options: {
                scales: {
                    xAxes: [
                        {
                            display: false,
                        }
                    ],
                    yAxes: [
                        {
                            display: false,
                        }
                    ]
                },
                tooltips: {
                    enabled: false
                },
                title: {
                    display: false
                },
                legend: {
                    display: false
                },
                responsive: true,
                maintainAspectRatio: false,
                layout: {
                    padding: {
                        left: 0,
                        right: 0,
                        top: 5,
                        bottom: 0
                    }
                }
            },
            doughnutData: {
                labels: [],
                datasets: [{
                    data: [],
                    backgroundColor: [],
                    borderColor: [
                        'transparent',
                        'transparent',
                        'transparent',
                        'transparent',
                    ],
                    hoverBorderColor: [
                        'transparent',
                        'transparent',
                        'transparent',
                        'transparent',
                    ],
                    hoverBackgroundColor: []
                }],
            },
            doughnutOptions: {
                scales: {
                    xAxes: [
                        {
                            display: false,
                        }
                    ],
                    yAxes: [
                        {
                            display: false,
                        }
                    ]
                },
                tooltips: {
                    enabled: false
                },
                title: {
                    display: false
                },
                legend: {
                    display: false
                },
                cutoutPercentage: 65,
                responsive: false,
                maintainAspectRatio: false,
            },
            open: false,
            chart: false,
            selected: "impressions",
            user_email: null,
            reseller: false,
            inhouse: false,
            branding: false,
            feeds: false,
            crm: false,
            leads: 0,
            engagement: 0,
            reactions: 0,
            facebook_feed_status: false,
            google_feed_status: false,
            tiktok_feed_status: false,
            snapchat_feed_status: false,
            isLoadingFeed: true,
            feed_channels: ["fb", "google"]
        };
        this._updateChartData = this._updateChartData.bind(this);
        this._archive = this._archive.bind(this);
    };

    componentWillMount() {

        //SET COLORS
        if(salesChannelRegister.get("name") === "propertybooster"){

            this.state.channels_style.line.instagram.backgroundColor = "rgba(204,237,243, 0.7)";
            this.state.channels_style.line.fb.backgroundColor = "rgba(51,184,207, 0.9)";
            this.state.channels_style.line.bing.backgroundColor = "rgba(153,219,231, 0.9)";
            this.state.channels_style.line.google.backgroundColor = "rgba(26,107,133, 0.9)";

            this.state.channels_style.doughnut.instagram.backgroundColor = "rgba(204,237,243, 0.7)";
            this.state.channels_style.doughnut.instagram.hoverBackgroundColor = "rgba(204,237,243, 0.7)";
            this.state.channels_style.doughnut.fb.backgroundColor = "rgba(51,184,207, 0.9)";
            this.state.channels_style.doughnut.fb.hoverBackgroundColor = "rgba(51,184,207, 0.9)";
            this.state.channels_style.doughnut.bing.backgroundColor = "rgba(153,219,231, 0.9)";
            this.state.channels_style.doughnut.bing.hoverBackgroundColor = "rgba(153,219,231, 0.9)";
            this.state.channels_style.doughnut.google.backgroundColor = "rgba(26,107,133, 0.9)";
            this.state.channels_style.doughnut.google.hoverBackgroundColor = "rgba(26,107,133, 0.9)";

            this.state.chartData.datasets[0].borderColor = "#33B8CF";
            this.state.chartData.datasets[0].pointHoverBorderColor = "#33B8CF";
            this.state.chartData.datasets[0].backgroundColor = "rgba(51,184,207, 0.7)";

            this.setState({
                channels_style: this.state.channels_style,
                chartData: this.state.chartData
            });

        }else if(salesChannelRegister.get("name") === "boostabostad"){

            this.state.channels_style.line.instagram.backgroundColor = "rgba(229,245,222, 0.7)";
            this.state.channels_style.line.fb.backgroundColor = "rgba(126,207,91, 0.9)";
            this.state.channels_style.line.bing.backgroundColor = "rgba(174,236,147, 0.9)";
            this.state.channels_style.line.google.backgroundColor = "rgba(104,171,75, 0.9)";

            this.state.channels_style.doughnut.instagram.backgroundColor = "rgba(229,245,222, 0.7)";
            this.state.channels_style.doughnut.instagram.hoverBackgroundColor = "rgba(229,245,222, 0.7)";
            this.state.channels_style.doughnut.fb.backgroundColor = "rgba(126,207,91, 0.9)";
            this.state.channels_style.doughnut.fb.hoverBackgroundColor = "rgba(126,207,91, 0.9)";
            this.state.channels_style.doughnut.bing.backgroundColor = "rgba(174,236,147, 0.9)";
            this.state.channels_style.doughnut.bing.hoverBackgroundColor = "rgba(174,236,147, 0.9)";
            this.state.channels_style.doughnut.google.backgroundColor = "rgba(104,171,75, 0.9)";
            this.state.channels_style.doughnut.google.hoverBackgroundColor = "rgba(104,171,75, 0.9)";

            this.state.chartData.datasets[0].borderColor = "#7ECF5B";
            this.state.chartData.datasets[0].pointHoverBorderColor = "#7ECF5B";
            this.state.chartData.datasets[0].backgroundColor = "rgba(126,207,91, 0.7)";

            this.setState({
                channels_style: this.state.channels_style,
                chartData: this.state.chartData
            });

        }else if(salesChannelRegister.get("name") === "yieldlock"){

            this.state.channels_style.line.instagram.backgroundColor = "rgba(230,233,235, 0.9)";
            this.state.channels_style.line.fb.backgroundColor = "rgba(128,147,157, 0.9)";
            this.state.channels_style.line.bing.backgroundColor = "rgba(191,201,206, 0.7)";
            this.state.channels_style.line.google.backgroundColor = "rgba(0,39,58, 0.9)";

            this.state.channels_style.doughnut.instagram.backgroundColor = "rgba(230,233,235, 0.9)";
            this.state.channels_style.doughnut.instagram.hoverBackgroundColor = "rgba(230,233,235, 0.9)";
            this.state.channels_style.doughnut.fb.backgroundColor = "rgba(128,147,157, 0.9)";
            this.state.channels_style.doughnut.fb.hoverBackgroundColor = "rgba(128,147,157, 0.9)";
            this.state.channels_style.doughnut.bing.backgroundColor = "rgba(191,201,206, 0.7)";
            this.state.channels_style.doughnut.bing.hoverBackgroundColor = "rgba(191,201,206, 0.7)";
            this.state.channels_style.doughnut.google.backgroundColor = "rgba(0,39,58, 0.9)";
            this.state.channels_style.doughnut.google.hoverBackgroundColor = "rgba(0,39,58, 0.9)";

            this.state.chartData.datasets[0].borderColor = "#00273A";
            this.state.chartData.datasets[0].pointHoverBorderColor = "#00273A";
            this.state.chartData.datasets[0].backgroundColor = "rgba(0,39,58, 0.7)";

            this.setState({
                channels_style: this.state.channels_style,
                chartData: this.state.chartData
            });

        }

        this._setValues();
    }

    componentWillReceiveProps() {
        this.setState({
            data: this.props.data,
            user: this.props.user,
            feed_pref: this.props.feed_pref
        }, () => {
            //this._updateChartData();
            this._updateUserData();
        });
    }

    _setValues() {
        this.setState({
            data: this.props.data,
            user: this.props.user,
            feed_pref: this.props.feed_pref
        }, () => {
            //this._updateChartData();
            this._updateUserData();
        });
    }

    _updateUserData() {
        if (this.state.user) {
            this.setState({
                user_email: this.state.user.email,
                reseller: (this.state.user.reseller || this.state.user.inhouse),
                inhouse: this.state.user.inhouse
            });
            if (this.state.user.socialData) {
                this.setState({
                    branding: this.state.user.socialData.branding ? this.state.user.socialData.branding : false,
                    crm: this.state.user.socialData.crm ? this.state.user.socialData.crm : false,
                    feeds: this.state.user.socialData.feeds ? this.state.user.socialData.feeds : false
                }, () => {
                    this._landingExpiry();
                    if (this.state.feeds) {
                        this._updateFeedData();
                    }
                });
            }
        }
    }

    _updateFeedData() {
            if (this.state.feed_pref) {
                this.setState({
                    facebook_feed_status: this.state.feed_pref.facebook_remarketing.status ? this.state.feed_pref.facebook_remarketing.status : false,
                    google_feed_status: this.state.feed_pref.google_remarketing.status ? this.state.feed_pref.google_remarketing.status : false,
                    tiktok_feed_status: this.state.feed_pref.tiktok_remarketing.status ? this.state.feed_pref.tiktok_remarketing.status : false,
                    snapchat_feed_status: this.state.feed_pref.snapchat_remarketing.status ? this.state.feed_pref.snapchat_remarketing.status : false
                }, () => {
                    this._renderFeeds();
                });
            } else {
                this._renderFeeds();
            }
    }

    _renderFeeds() {

        let feed_channels = [];
        if (this.state.facebook_feed_status)
        {
            feed_channels.push("fb");
        }
        if (this.state.google_feed_status)
        {
            feed_channels.push("google");
        }
        if (this.state.tiktok_feed_status)
        {
            feed_channels.push("tiktok");
        }
        if (this.state.snapchat_feed_status)
        {
            feed_channels.push("snapchat");
        }

        this.setState({
            feed_channels: feed_channels
        }, () => {
            this.setState({isLoadingFeed: false})
        });
    }

    _landingExpiry() {
        if (this.state.branding) {
            this.setState({
                landing_expiry: 361
            });
        }
    }

    _updateChartData() {
        let datasets = [];
        this.setState({show: false});

        //test

        try {
            let value = this.state.data.total_observations;
            value++;
            this.state.chartData.labels = [];
            for(let i = 0; i < value; i++){
                this.state.chartData.labels.push(i);
            }
        }catch (e) {
            console.log(e);
        }

        if (this.state.open) {

            try{
                let channels_observations = {};
                for(let i = 0; i < this.state.data.observations.length; i++){
                    for(let m = 0; m < this.state.data.channels.length; m++){
                        let key = this.state.data.channels[m];
                        if(channels_observations[key]){
                            if(this.state.data.observations[i].channels[key]){
                                if(this.state.selected === 'call'){
                                    try {
                                        channels_observations[key].observations.push(this.state.data.observations[i].channels[key]['details']['withExtension']['Phone calls']['clicks']?parseInt(this.state.data.observations[i].channels[key]['details']['withExtension']['Phone calls']['clicks']):0);
                                    }catch (e) {
                                        channels_observations[key].observations.push(0);
                                    }
                                }else{
                                    channels_observations[key].observations.push(this.state.data.observations[i].channels[key][this.state.selected]?parseInt(this.state.data.observations[i].channels[key][this.state.selected]):0);
                                }
                            }
                        }else{
                            if(this.state.data.observations[i].channels[key]){
                                channels_observations[key] = {backgroundColor: null, observations: [0], title: null};
                                channels_observations[key].backgroundColor = this.state.channels_style.line[key].backgroundColor;
                                channels_observations[key].title = this.state.channels_style.line[key].title;
                                channels_observations[key].observations.push(this.state.data.observations[i].channels[key][this.state.selected]?parseInt(this.state.data.observations[i].channels[key][this.state.selected]):0);
                            }
                        }
                    }
                }
                for(let m = 0; m < this.state.data.channels.length; m++){
                    try{
                        let key = this.state.data.channels[m];
                        datasets.unshift({
                            data: channels_observations[key].observations,
                            backgroundColor: channels_observations[key].backgroundColor,
                            borderColor: 'transparent',
                            radius: 0,
                            label: channels_observations[key].title
                        });
                    }catch (e) {}
                }

                // SET DOUGHNUT DATA
                let observations = [];
                let channels = {};
                for(let i = 0; i < this.state.data.observations.length; i++){
                    for(let m = 0; m < this.state.data.channels.length; m++) {
                        let key = this.state.data.channels[m];
                        if(channels[key]){
                            if(this.state.data.observations[i].channels[key] && this.state.data.observations[i].channels[key][this.state.selected]){
                                channels[key].value = channels[key].value + parseInt(this.state.data.observations[i].channels[key][this.state.selected]);
                            }else{
                                channels[key].value = channels[key].value + 0;
                            }
                        }else{
                            channels[key] = {};
                            channels[key].title = this.state.channels_style.doughnut[key].title;
                            channels[key].backgroundColor = this.state.channels_style.doughnut[key].backgroundColor;
                            channels[key].hoverBackgroundColor = this.state.channels_style.doughnut[key].hoverBackgroundColor;
                            if(this.state.data.observations[i].channels[key] && this.state.data.observations[i].channels[key][this.state.selected]){
                                channels[key].value = parseInt(this.state.data.observations[i].channels[key][this.state.selected]);
                            }else{
                                channels[key].value = 0;
                            }
                        }
                    }
                }

                for(var key in channels){
                    this.state.doughnutData.labels.unshift(channels[key].title);
                    this.state.doughnutData.datasets[0].backgroundColor.unshift(channels[key].backgroundColor);
                    this.state.doughnutData.datasets[0].hoverBackgroundColor.unshift(channels[key].hoverBackgroundColor);
                    observations.unshift(channels[key].value);
                }

                this.state.doughnutData.datasets[0].data = observations;
                this.setState({
                    chartData: Object.assign({}, this.state.chartData, {
                        datasets: datasets
                    }),
                    doughnutData: this.state.doughnutData
                });
            }catch (e) {
               console.log(e);
            }

        }else{

            try{
                let observations = [0];
                for(let i = 0; i < this.state.data.observations.length; i++){
                    let value = 0;
                    for(let key in this.state.data.observations[i].channels){
                        if(this.state.data.observations[i].channels[key][this.state.selected]){
                            value = value + parseInt(this.state.data.observations[i].channels[key][this.state.selected]);
                        }
                    }
                    observations.push(value)
                }

                if(salesChannelRegister.get('name') === "propertybooster"){
                    datasets = [{
                        backgroundColor: 'rgba(51,184,207,0.7)',
                        borderColor: '#33B8CF',
                        borderWidth: 2,
                        radius: 4,
                        pointBackgroundColor: "#ffffff",
                        pointHoverBorderColor: '#33B8CF',
                        pointHoverBackgroundColor: "#ffffff",
                        data: observations
                    }];
                }else if(salesChannelRegister.get('name') === "boostabostad"){
                    datasets = [{
                        backgroundColor: "rgba(229,245,222,0.7)",
                        borderColor: '#7ECF5B',
                        borderWidth: 2,
                        radius: 4,
                        pointBackgroundColor: "#ffffff",
                        pointHoverBorderColor: '#7ECF5B',
                        pointHoverBackgroundColor: "#ffffff",
                        data: observations
                    }];
                }else if(salesChannelRegister.get('name') === "yieldlock"){
                    datasets = [{
                        backgroundColor: "rgba(0, 39, 58, 0.7)",
                        borderColor: '#E65032',
                        borderWidth: 2,
                        radius: 4,
                        pointBackgroundColor: "#ffffff",
                        pointHoverBorderColor: '#E65032',
                        pointHoverBackgroundColor: "#ffffff",
                        data: observations
                    }];
                }

                this.setState({
                    chartData: Object.assign({}, this.state.chartData, {
                        datasets: datasets
                    })
                });
            }catch (e) {
                console.log(e);
            }

        }
        setTimeout(() => {
            this.setState({show: true});
        }, 100);
    }

    _toggleCard() {
        this.setState({selected: this.state.open ? "impressions" : this.state.selected, open: !this.state.open}, () => {
            this._updateChartData();
        });
    }

    _edit() {
        this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/user/campaigns/drafts/" + this.state.data.hash);
    }

    _gotoLeads() {
        this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/user/campaigns/drafts/" + this.state.data.hash + "?leads=true");
    }

    _invoice() {
        window.open("https://invoice." + dataRegister.domain + "/" + salesChannelRegister.get('market') + "/" + this.state.data.hash, '_blank');
    }

    _selectData(option) {
        if (option === "leads" && this.state.data && this.state.data.leads && this.state.data.leads > 0) {
            this._gotoLeads();
        } else {
        if (this.state.data.status === "RUNNING") {
            this.setState({selected: option}, () => {
                this._updateChartData();
            });
        }
        }
    }

    _archive(value){
        if(value){
            this.setState({modal: false}, () => {
                this.props.setLoader(true);
                dataRegister.archiveCampaign(salesChannelRegister.get('market'), langRegister.lang(), this.state.data.hash).then((response) => {
                    this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/user/campaigns/archived");

                    // Upon archive deactivets active landing pages
                    if (this.state.data.landingpage && !this.state.data.landingpage_data.expired) {
                    dataRegister.setStatusLanding(salesChannelRegister.get('market'), this.state.data.landingpage_data.id, {active: false}).then((response) => {
                        console.log("landing page deactivation success")
                    }, (error) => {
                        console.log("landing page deactivation error")
                    });
                    }

                }, (error) => {
                    this.props.setLoader(false);
                });
            });
        }else{
            this.setState({modal: false});
        }
    }

    _new(){
        try{
            this.props.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "?url=https://enterprise.adbooster.se/listings/scrape/" + this.state.data.landingpage_data.id);
        }catch (error) {}
    }

    _getYieldlockData(type){
        dataRegister.singleCampaign(salesChannelRegister.get('market'), langRegister.lang(), this.state.data.hash).then((response) => {
            console.log(response);
            if (!response.errors && response.landing_extra && typeof response.landing_extra === "object" && response.landing_extra.yieldlock && typeof response.landing_extra.yieldlock === "object") {
                var getUrl = window.location;
                var test = getUrl.href;
                console.log(test);
                let new_url = test.replace('user/campaigns/drafts', 'pdf/yieldlock?');
                console.log(new_url);
                let data = {
                    type: type === 'buyer'?"buyer":response.landing_extra.yieldlock.type,
                    amenities: response.landing_extra.yieldlock.amenities,
                    lat: response.landing_extra.yieldlock.lat,
                    lng: response.landing_extra.yieldlock.lng,
                    location: response.landing_extra.yieldlock.location,
                    industry: response.landing_extra.yieldlock.industry,
                    beds: response.landing_extra.yieldlock.beds,
                    property_type: response.landing_extra.yieldlock.property_type,
                    property_status: response.landing_extra.yieldlock.property_status,
                    baths: response.landing_extra.yieldlock.baths,
                    sqft: response.landing_extra.yieldlock.sqft,
                    sqm: response.landing_extra.yieldlock.sqm,
                    image: response.landing_extra.yieldlock.image,
                    market_rent: response.landing_extra.yieldlock.market_rent,
                    list_rent: response.landing_extra.yieldlock.rent_boost,
                    market_price: response.landing_extra.yieldlock.market_price,
                    years: response.landing_extra.yieldlock.years,
                    list_price: response.landing_extra.yieldlock.list_price,
                    yield: response.landing_extra.yieldlock.yield,
                    up_front: response.landing_extra.yieldlock.upfront,
                    currency: response.landing_extra.yieldlock.currency,
                    broker_image: typeof this.state.user === 'object'?this.state.user.profile_image:null,
                    broker_email: typeof this.state.user === 'object'?this.state.user.email:null,
                    broker_phone: typeof this.state.user === 'object'?this.state.user.phone:null,
                    broker_name: typeof this.state.user === 'object'?(this.state.user.name + " " + this.state.user.surname):null
                };
                let query = queryString.stringify(data);
                new_url = new_url + query;
                window.open(new_url);
            }
        }, (error) => {});
    }

    _renderTotalClicks(data){
        let leads = 0;
        for(let i = 0; i < data.length; i++){
            for(let key in data[i].channels){
                if(data[i].channels[key].clicks){
                    leads = leads + parseInt(data[i].channels[key].clicks);
                }
            }
        }
        return leads;
    }

    _renderTotalImpressions(data){
        let impressions = 0;
        for(let i = 0; i < data.length; i++){
            for(let key in data[i].channels){
                if(data[i].channels[key].impressions){
                    impressions = impressions + parseInt(data[i].channels[key].impressions);
                }
            }
        }
        return impressions;
    }

    _renderTotalCalls(data){
        let calls = 0;
        for(let i = 0; i < data.length; i++){
            for(let key in data[i].channels){
                try {
                    calls = calls + parseInt(data[i].channels[key]['details']['clicks_by_origin']['withExtension']['Phone calls']['clicks']);
                }catch (e) {
                    calls = calls + 0;
                }
            }
        }
        if(calls < 1){
            return '...';
        }else{
            return calls;
        }
    }

    _renderPercentage(data) {
        if (data.days === 0) {
            return 0
        } else {
            let percentage = data.days / parseInt(data.duration);
            percentage = percentage * 100;
            if(percentage > 99){
                return 99;
            }else{
                return Math.floor(percentage);
            }
        }
    }

    _renderLandingExpired() {
        let date1 = new Date(this.state.data.latest_update);
        let date2 = new Date(this.state.today);
        let diff = parseInt((date2 - date1) / (1000 * 60 * 60 * 24), 10)
        return diff;
    }

    _renderIcon(key) {
        if (salesChannelRegister.get("name") === "yieldlock") {
            let color = "#00273A";
            if (this.state.open){
                if (key === "google"){
                    color = "rgb(0,39,58)";
                } else if (key === "fb"){
                    color = "rgb(128,147,157)";
                } else if (key === "instagram"){
                    color = "rgb(230,233,235)";
                } else if (key === "bing"){
                    color = "rgb(191,201,206)";
                } else {
                    color = "rgb(0, 39, 58)";
                }
            }
            let size = "cardSubtitleInnerIconsItem" + key;
            return (
                <div style={{backgroundColor: color}} className={cx(Styles.cardSubtitleInnerIconsItem)}>
                    <img className={Styles[size]} src={require("../../assets/images/" + key + "_logo_icon.svg")}/>
                </div>
            )
        } else if (salesChannelRegister.get("name") === "propertybooster") {
            let color = "#000000";
            if (this.state.open){
                if (key === "google"){
                    color = "rgb(26,107,133)";
                } else if (key === "fb"){
                    color = "rgb(51,184,207)";
                } else if (key === "instagram"){
                    color = "rgb(204,237,243)";
                } else if (key === "bing"){
                    color = "rgb(153,219,231)";
                } else {
                    color = "rgb(0,0,0)";
                }
            }
            let size = "cardSubtitleInnerIconsItem" + key;
            return (
                <div style={{backgroundColor: color}} className={cx(Styles.cardSubtitleInnerIconsItem)}>
                    <img className={Styles[size]} src={require("../../assets/images/" + key + "_logo_icon.svg")}/>
                </div>
            )
        } else if (salesChannelRegister.get("name") === "boostabostad") {
            let color = "#000000";
            if (this.state.open){
                if (key === "google"){
                    color = "rgb(104,171,75)";
                } else if (key === "fb"){
                    color = "rgb(126,207,91)";
                } else if (key === "instagram"){
                    color = "rgb(229,245,222)";
                } else if (key === "bing"){
                    color = "rgb(174,236,147)";
                } else {
                    color = "rgb(0,0,0)";
                }
            }
            let size = "cardSubtitleInnerIconsItem" + key;
            return (
                <div style={{backgroundColor: color}} className={cx(Styles.cardSubtitleInnerIconsItem)}>
                    <img className={Styles[size]} src={require("../../assets/images/" + key + "_logo_icon.svg")}/>
                </div>
            )
        } else {
            let color = "cardSubtitleInnerIconsItemColor" + key;
            let size = "cardSubtitleInnerIconsItem" + key;
            return (
                <div className={
                    cx(Styles.cardSubtitleInnerIconsItem,
                        {
                            [Styles[color]]: this.state.open
                        })
                }>
                    <img className={Styles[size]} src={require("../../assets/images/" + key + "_logo_icon.svg")}/>
                </div>
            )
        }
    }

    _renderLang(lang) {
        if (lang === "sv") {
            return langRegister.lang() === "sv" ? "Svenska" : "Swedish"
        } else if (lang === "en") {
            return langRegister.lang() === "sv" ? "Engelska" : "English"
        }
    }

    _renderNumbers(x) {
        try {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        } catch (e) {
            return ("...")
        }
    }

    _renderText(item) {
        return langRegister.get("user-campaigns-drafts-item", item);
    }


    _renderIndustry (industry) {
        if (window.innerWidth <= 1050) {
            let input = industry;
            if (input.length > 12) {
                return input.substring(0, 12) + '...';
            } else {
                return input
            }
        } else {
            return industry
        }
    }

    render() {
        return (
            <div>
                {
                    this.state.modal &&
                    <ModalArchive setArchive={this._archive} landingpage={this.state.data.landingpage} landingpage_data={this.state.data.landingpage_data}/>
                }
                {
                    this.state.data &&
                    <div id={this.state.id} className={
                        cx(Styles.card,
                            {
                                [Styles.cardOpen]: this.state.open
                            })
                    }>
                        {
                            /*
                            // activate if need to archive drafts manually
                            this.state.data.status === "DRAFT" &&
                            <div onClick={() => this.setState({modal: true})} className={Styles.archiveButton}>
                                <img className={Styles.archiveButtonIcon} src={require('../../assets/images/close_icon_2_white.svg')}/>
                            </div>
                            */
                        }
                        <div className={Styles.cardTitle}>
                            <span>{this._renderIndustry(this.state.data.industry)}</span>&nbsp;#{this.state.data.id}
                        </div>
                        <div className={Styles.cardSubtitle}>
                            <div className={Styles.cardSubtitleInner}>
                                {
                                    /*
                                    <div className={Styles.cardSubtitleInnerText}>{this._renderLang(this.state.data.language)}</div>
                                    */
                                }
                                {
                                    this.state.data.optimization === "1" &&
                                    <div
                                        className={Styles.cardSubtitleInnerText}>{this._renderText("item_18")}</div>
                                }
                                {
                                    this.state.data.optimization === "2" &&
                                    <div
                                        className={Styles.cardSubtitleInnerText}>{this._renderText("item_17")}</div>
                                }
                                <div className={Styles.cardSubtitleInnerIcons}>
                                    {
                                       this.state.feeds && this.state.feed_channels && !this.state.isLoadingFeed &&
                                       this.state.feed_channels.map((key, i) => {
                                            return (
                                                this._renderIcon(key)
                                            )
                                        })
                                    }
                                    {
                                        !this.state.feeds && this.state.feed_channels &&
                                        this.state.feed_channels.map((key, i) => {
                                            return (
                                                this._renderIcon(key)
                                            )
                                        })
                                    }
                                </div>
                            </div>
                            {
                                this.state.reseller &&
                                <div className={Styles.cardTitleCompanyName}>{this.state.data.company_name}</div>
                            }
                            {
                                this.state.reseller &&
                                <span className={Styles.cardTitleRef}>{this.state.data.ref ? this.state.data.ref : ""}</span>
                            }
                            {
                                this.state.reseller && this.state.data.latest_update && this.state.data.ref &&
                                <span className={Styles.cardTitleUpdate}>{" | "}</span>
                            }
                            {
                                this.state.reseller &&
                                <span className={Styles.cardTitleUpdate}>{this.state.data.latest_update ? this._renderText("item_27") + this.state.data.latest_update : "" }</span>
                            }
                        </div>
                        <div className={
                            cx(Styles.cardLeft,
                                {
                                    [Styles.cardLeftOpen]: this.state.open
                                })
                        }>
                            {
                                <div className={Styles.cardDonutChartContainer}>
                                    <svg viewBox="0 0 36 36" className={Styles.cardDonutChartContainerCircular}>
                                        <path className={Styles.cardDonutChartContainerBg}
                                              d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
                                        />
                                        <text x="17.5" y="19.35"
                                              className={Styles.cardDonutChartContainerPercentage}>{this._renderText("item_24")}</text>
                                        <text x="18" y="24.35"
                                              className={Styles.cardDonutChartContainerTitle}>{this._renderText("item_25")}</text>
                                    </svg>
                                </div>
                            }
                            <div className={Styles.cardDonutChartContainerInner}/>
                            {
                                this.state.data.status === "DRAFT" && this.state.reseller &&
                                <div onClick={() => this._edit()} className={
                                    cx(Styles.cardEditButton, Styles.cardEditButtonUnpaid,
                                        {
                                            [Styles.cardEditButtonOpen]: this.state.open,
                                        })
                                }>
                                    {this._renderText("item_1")}
                                </div>
                            }
                            {
                                this.state.data.status === "DRAFT" &&
                                <div style={salesChannelRegister.get('name')==='yieldlock'?{backgroundColor: 'rgb(230, 80, 50)'}:{}} onClick={() => this._new()}
                                     className={cx(Styles.cardEditButton,
                                     {
                                         [Styles.cardEditButtonBoost]: !this.state.reseller,
                                         [Styles.cardEditButtonBoostInhouse]: this.state.reseller,
                                     })
                                     }>
                                    {this._renderText("item_22")}
                                </div>
                            }
                            <div className={Styles.cardStatusContainer}>
                                {
                                    this.state.data.broker_image && this.state.inhouse &&
                                    <div className={Styles.brokerContainer}><div style={{backgroundImage: "url(" + this.state.data.broker_image + ")"}} className={Styles.brokerImage}></div></div>
                                }
                                <div className={
                                    cx(Styles.cardStatus,
                                        {
                                            [Styles.cardStatusPending]: this.state.data.status === "DRAFT"
                                        })
                                }>
                                    {
                                        <div className={
                                            cx(Styles.cardStatusDot,
                                                {
                                                    [Styles.cardStatusPending]: this.state.data.status === "DRAFT"
                                                })
                                        }>
                                            &#9679;
                                        </div>
                                    }
                                    <div className={
                                        cx(Styles.cardStatusTitle,
                                            {
                                                [Styles.cardStatusPending]: this.state.data.status === "DRAFT"
                                            })
                                    }>
                                        {
                                            this.state.data.status === "DRAFT" &&
                                            <span>{this._renderText("item_23")}</span>
                                        }
                                    </div>
                                    <div className={Styles.fwdStatusContainer}>
                                        {
                                            this.state.data.redirect &&
                                            <div className={Styles.fwdStatus}>
                                                <img className={Styles.fwdStatusIcon} src={require("../../assets/images/arrow_forward.svg")}/>
                                            </div>
                                        }
                                        {
                                            this.state.data.redirect && this.state.data.landingpage &&
                                            <div className={Styles.fwdStatusContainerSpace}/>
                                        }
                                        {
                                            this.state.data.landingpage && !this.state.data.landingpage_data.expired &&
                                            <div className={Styles.fwdStatus}>
                                                <img className={Styles.fwdStatusIcon} src={require("../../assets/images/link_grey.svg")}/>
                                            </div>
                                        }
                                        {
                                            this.state.data.landingpage && this.state.data.landingpage_data.expired && salesChannelRegister.get("name") !== "yieldlock" &&
                                            <div className={Styles.fwdStatusWarning}>
                                                <img className={Styles.fwdStatusIcon} src={require("../../assets/images/link_warning.svg")}/>
                                            </div>
                                        }
                                        {
                                            this.state.data.landingpage && this.state.data.landingpage_data.expired && salesChannelRegister.get("name") === "yieldlock" &&
                                            <div className={Styles.fwdStatusWarningYieldlock}>
                                                <img className={Styles.fwdStatusIcon} src={require("../../assets/images/link_warning_yl.svg")}/>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className={Styles.cardLeftInner}>
                                {
                                    this.state.show && this.state.data.observations.length > 0 &&
                                    <Line
                                        ref={ref => this.chartInstance = ref && ref.chartInstance}
                                        data={this.state.chartData}
                                        options={this.state.options}
                                    />
                                }
                            </div>
                            <div style={{width: (100 - this.state.percentage) + "%"}}
                                 className={Styles.cardLeftOverlay}/>
                        </div>
                        <div className={
                            cx(Styles.cardRight,
                                {
                                    [Styles.cardRightOpenMobile]: this.state.open
                                })
                        }>
                            {
                                this.state.data.status === "DRAFT" && !this.state.data.landingpage &&
                                <div className={Styles.cardRightImpressions2}>
                                    <div className={Styles.cardRightImpressionsInner}>
                                        <div className={Styles.cardRightImpressionsInnerTitle}>
                                            {this._renderText("item_3")}
                                        </div>
                                        <div className={Styles.cardRightImpressionsInnerValue}>
                                            {this._renderNumbers(this._renderTotalImpressions(this.state.data.observations))}
                                        </div>
                                    </div>
                                    {
                                        this.state.selected === "impressions" && this.state.data.status === "RUNNING" &&
                                        <div className={Styles.selector}/>
                                    }
                                </div>
                            }
                            {
                                this.state.data.status === "DRAFT" && this.state.data.landingpage &&
                                <div className={Styles.cardRightImpressions2}>
                                    <div className={Styles.cardRightImpressionsInner}>
                                        {
                                            this.state.data && this.state.data.landingpage_data && !this.state.data.landingpage_data.expired &&
                                        <div className={Styles.cardRightImpressionsInnerTitle}>
                                            {this._renderText("item_19")}
                                        </div>
                                        }
                                        {
                                            this.state.data && this.state.data.landingpage_data && this.state.data.landingpage_data.expired &&
                                            <div className={Styles.cardRightImpressionsInnerTitle}>
                                                {this._renderText("item_20")}
                                            </div>
                                        }
                                        {
                                            this.state.data && this.state.data.landingpage_data && !this.state.data.landingpage_data.expired &&
                                        <div className={Styles.cardRightImpressionsInnerValue}>
                                            <Moment diff={this.state.today} unit="days" add={{days: this.state.landing_expiry}}>{this.state.data.latest_update}</Moment>
                                        </div>
                                        }
                                        {
                                            this.state.data && this.state.data.landingpage_data && this.state.data.landingpage_data.expired &&
                                            <div className={Styles.cardRightImpressionsInnerValue}>
                                                {this._renderText("item_21")}
                                            </div>
                                        }
                                    </div>
                                </div>
                            }
                            {
                                this.state.data.status === "DRAFT" && this.state.data.landingpage &&
                                <div className={Styles.cardRightClicks2}>
                                    <div onClick={() => this._selectData("leads")} style={{cursor: "pointer"}} className={Styles.cardRightClicksInner}>
                                        <div className={Styles.cardRightClicksInnerTitle}>
                                            {this._renderText("item_16")}
                                        </div>
                                        <div className={Styles.cardRightClicksInnerValue}>
                                            {this.state.data.leads}
                                        </div>
                                    </div>
                                </div>
                            }
                            {
                                this.state.data.status === "DRAFT" && !this.state.data.landingpage &&
                                <div className={Styles.cardRightClicks2}>
                                    <div className={Styles.cardRightClicksInner}>
                                        <div className={Styles.cardRightClicksInnerTitle}>
                                            {this._renderText("item_4")}
                                        </div>
                                        <div className={Styles.cardRightClicksInnerValue}>
                                            {this._renderNumbers(this._renderTotalClicks(this.state.data.observations))}
                                        </div>
                                    </div>
                                    {
                                        this.state.selected === "clicks" &&
                                        <div className={Styles.selector}/>
                                    }
                                </div>
                            }
                            {
                                this.state.open && (!this.state.data.leads || (this.state.data && this.state.data.leads && this.state.data.leads < 1)) &&
                                <div onClick={() => this._selectData("call")} className={
                                    cx(Styles.cardRightImpressions,
                                        {
                                            [Styles.cardRightOpen]: this.state.open
                                        })
                                }>
                                    <div className={Styles.cardRightImpressionsInner}>
                                        <div className={Styles.cardRightImpressionsInnerTitle}>
                                            {this._renderText("item_5")}
                                        </div>
                                        <div className={Styles.cardRightImpressionsInnerValue}>
                                            {this._renderNumbers(this._renderTotalCalls(this.state.data.observations))}
                                        </div>
                                    </div>
                                    {
                                        this.state.selected === "call" &&
                                        <div className={Styles.selector}/>
                                    }
                                </div>
                            }
                            {
                                this.state.open && this.state.data && this.state.data.leads && this.state.data.leads > 0 &&
                                <div onClick={() => this._selectData("leads")} className={
                                    cx(Styles.cardRightImpressions,
                                        {
                                            [Styles.cardRightOpen]: this.state.open
                                        })
                                }>
                                    <div className={Styles.cardRightImpressionsInner}>
                                        <div className={Styles.cardRightImpressionsInnerTitle}>
                                            {this._renderText("item_16")}
                                        </div>
                                        <div className={Styles.cardRightImpressionsInnerValue}>
                                            {this.state.data.leads}
                                        </div>
                                        {
                                            this.state.selected === "leads" &&
                                            <div className={Styles.selector}/>
                                        }
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                }
            </div>
        );
    }
}

export default userCampaignsDraftsItem;


// WEBPACK FOOTER //
// ./src/components/user-campaigns-drafts-item/component.js